import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import {DocumentosPessoaisDto} from "../../components/recadastramento-aba3/documentosPessoais.dto";
import {CategoriasCnhDto} from "../../model/categoriasCnh.dto";
import {OrgaoEmissorDto} from "../../model/orgaoEmissor";
import {ArquivoBlobDTO} from "../../model/arquivoBlob.dto";

@Injectable()
export class DocumentosPessoaisAba3Service extends GenericService {

    private basePath = 'api/v1';
    private path = '/documentos-pessoais';
    url = environment.url;

    constructor(http: HttpClient) {
        super(http);
    }

    getDocumentosPessoais(): Observable<DocumentosPessoaisDto> {
        return this.http.get<DocumentosPessoaisDto>(this.url + this.basePath + this.path +'/obter-dados');
    }

    getCategoriasCnh(): Observable<CategoriasCnhDto[]> {
        return this.http.get<CategoriasCnhDto[]>(this.url + this.basePath + '/categoria-cnh');
    }

    getTiposOrgaoEmissor(): Observable<OrgaoEmissorDto[]> {
        return this.http.get<OrgaoEmissorDto[]>(this.url + this.basePath + '/orgao-emissor');
    }

    getArquivos(tipo: string): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + this.path + '/obter-documentos-pessoais/visualizar/' + tipo, options);
    }

    salvarDocumentosPessoais(data): Observable<any> {
        return this.http.post(this.url + this.basePath + this.path + "/salvar-dados-pessoais", data);
    }
    uploadComprovanteRg(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.postMethodFile(this.basePath + this.path + '/upload-documentos-pessoais/rg', formData);
    }

    uploadComprovanteCnh(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.postMethodFile(this.basePath + this.path + '/upload-documentos-pessoais/cnh', formData);
    }

    uploadComprovanteTitulo(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.postMethodFile(this.basePath + this.path + '/upload-documentos-pessoais/titulo-eleitor', formData);
    }

    deletarComprovanteRg() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.basePath + this.path + `/delete-documentos-pessoais/rg`, options);
    }

    deletarComprovanteCnh() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.basePath + this.path + `/delete-documentos-pessoais/cnh`, options);
    }

    deletarComprovanteTitulo() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.url + this.basePath + this.path + `/delete-documentos-pessoais/titulo-eleitor`, options);
    }

}
